import lightGrayButtonRule from '../../../light-gray/background/default/primary';

const primary = (params) => lightGrayButtonRule(params);

export default primary;
